import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=449ff72c&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=449ff72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ff72c",
  null
  
)

export default component.exports